(function () {
var $d41360ee8599201b$export$e1252723db1c541 = {
    externalVideoContainer: '.video--external',
    internalVideoContainer: '.video--internal',
    videoElement: 'video',
    videoConsent: '.video__consent'
};
var $d41360ee8599201b$export$ce4ab0c55987d1ff = {
    muted: 'video__audio-trigger--muted',
    videoBlocked: 'blocked'
};
var $d41360ee8599201b$var$trackYoutubeIframe = function() {
    // To track user behavior, the iframe API must be included.
    var src = 'https://www.youtube.com/iframe_api';
    // check if already loaded
    if (!document.querySelector('script[src="'.concat(src, '"]'))) {
        var script = document.createElement('script');
        script.src = src;
        document.head.appendChild(script);
    }
};
var $d41360ee8599201b$export$ce84bb03b7c3c023 = function(video) {
    return video.mozHasAudio || Boolean(video.webkitAudioDecodedByteCount) || Boolean(video.audioTracks && video.audioTracks.length);
};
var $d41360ee8599201b$export$58ce55ca15086934 = function(el) {
    var container = el.querySelector('.youtube');
    if (!container) return;
    var src = container.getAttribute('data-src');
    if (src) {
        // remove blocked class
        el.classList.remove($d41360ee8599201b$export$ce4ab0c55987d1ff.videoBlocked);
        // Update src to autoplay
        //! Important: mute=1 is necessary to autoplay the video
        src = src.replace('autoplay=0', 'autoplay=1');
        src = src.replace('mute=0', 'mute=1');
        // Create iframe
        var iframe = '<iframe src="'.concat(src, '" frameborder="0" allow="autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
        container.innerHTML = iframe;
        // Track iframe
        $d41360ee8599201b$var$trackYoutubeIframe();
    }
};


window.addEventListener('load', function() {
    // Handle internal videos.
    document.querySelectorAll((0, $d41360ee8599201b$export$e1252723db1c541).internalVideoContainer).forEach(function(el) {
        $5c18a35da0068e3f$var$displayAudioTrigger(el.querySelector((0, $d41360ee8599201b$export$e1252723db1c541).videoElement));
    });
    // Handle external videos.
    document.querySelectorAll((0, $d41360ee8599201b$export$e1252723db1c541).externalVideoContainer).forEach(function(el) {
        el.addEventListener('click', function() {
            if (el.classList.contains((0, $d41360ee8599201b$export$ce4ab0c55987d1ff).videoBlocked)) (0, $d41360ee8599201b$export$58ce55ca15086934)(el);
        });
    });
});
var $5c18a35da0068e3f$var$displayAudioTrigger = function(video) {
    if (!video.hasAttribute('controls') && (0, $d41360ee8599201b$export$ce84bb03b7c3c023)(video)) {
        var audioTrigger = document.createElement('div');
        audioTrigger.classList.add('video__audio-trigger', (0, $d41360ee8599201b$export$ce4ab0c55987d1ff).muted);
        video.parentNode.appendChild(audioTrigger);
        audioTrigger.addEventListener('click', function() {
            video.muted = !video.muted;
            audioTrigger.classList.toggle((0, $d41360ee8599201b$export$ce4ab0c55987d1ff).muted);
        });
    }
};
// Listen for color scheme changes
document.addEventListener('colorModeChange', function(e) {
    if (!(e instanceof CustomEvent)) return;
    document.querySelectorAll((0, $d41360ee8599201b$export$e1252723db1c541).videoConsent).forEach(function(el) {
        el.setAttribute('data-color-scheme', e.detail);
    });
});

})();
//# sourceMappingURL=video.min.js.map
